import { useNavigate } from "react-router-dom";
import { InternshipSchedule, PUser } from "../apis";
import { APPC, cPath, LSC } from "../config";

type useMessageRedirectType = {
    redirectMessageO2O: (
        targetUser: PUser,
        companyId?: number,
        schoolId?: number
    ) => void;
    redirectMessageInternship: (
        targetUser: PUser,
        internshipSchedule: InternshipSchedule,
        companyId?: number,
        schoolId?: number
    ) => void;
    redirectMessageClearActiveTab: () => void;
};

export const useMessageRedirect = (): useMessageRedirectType => {
    const navigate = useNavigate();

    const redirectMessageO2O = async (
        targetUser: PUser,
        companyId?: number,
        schoolId?: number
    ) => {
        await localStorage.setItem(
            LSC.APP_THREAD_INFO,
            JSON.stringify({
                activeTab: APPC.BE.MessageThread.TYPE.TYPE_O2O,
                type: APPC.BE.MessageThread.TYPE.TYPE_O2O,
                targetUser,
                companyId,
                schoolId,
            })
        );

        navigate(cPath("ADMIN.MESSAGES_PAGE"));
    };

    const redirectMessageInternship = async (
        targetUser: PUser,
        internshipSchedule: InternshipSchedule,
        schoolId?: number
    ) => {
        await localStorage.setItem(
            LSC.APP_THREAD_INFO,
            JSON.stringify({
                activeTab: APPC.BE.MessageThread.TYPE.TYPE_INTERNSHIP,
                type: APPC.BE.MessageThread.TYPE.TYPE_INTERNSHIP,
                targetUser,
                internshipSchedule,
                schoolId,
            })
        );

        navigate(cPath("ADMIN.MESSAGES_PAGE"));
    };

    const redirectMessageClearActiveTab = async () => {
        const threadInfo = await JSON.parse(
            localStorage.getItem(LSC.APP_THREAD_INFO) || "null"
        );
        await localStorage.setItem(
            LSC.APP_THREAD_INFO,
            JSON.stringify({ ...threadInfo, activeTab: "" })
        );
    };

    return {
        redirectMessageO2O,
        redirectMessageInternship,
        redirectMessageClearActiveTab,
    };
};
